module.exports = __webpack_public_path__ + "static/media/Ski_success.b8ac04e1.mp4";